import { useRef, useEffect, useState } from "react"
import * as d3 from "d3"

const LoadingTimes = ({ data, loading, colors }) => {
  const svgRef = useRef()
  const [svgWidth, setSvgWidth] = useState(0)
  const [svgHeight, setSvgHeight] = useState(0)
  const bufferBottom = svgHeight * 0.25
  const bufferTop = svgHeight * 0.04
  const bufferLeft = svgWidth * 0.15
  const bufferRight = svgWidth * 0.01
  const barWidth = ((svgWidth - bufferLeft - bufferRight) / 2) * 0.8
  useEffect(() => {
    if (data.length) {
      const svg = d3.select(svgRef.current).select("svg")
      svg.selectAll("*").remove()
      setSvgWidth(svgRef.current.clientWidth)
      setSvgHeight(svgRef.current.clientHeight)
      svg.attr("width", "100%").attr("height", "100%")
      const maxValue = Math.max(...data.map((d) => d.y))
      // color scale
      const colorScale = d3.scaleLinear().domain([0, 1]).range(colors)
      // y axis
      const yScale = d3
        .scaleLinear()
        .domain([maxValue + 5, 0])
        .range([bufferTop, svgHeight - bufferBottom])
        .nice()
      const yAxis = d3.axisLeft(yScale).ticks(3).tickSizeOuter(0)
      svg
        .append("g")
        .attr("class", "warehouse-graph-labels")
        .attr("transform", `translate(${bufferLeft},0)`)
        .call(yAxis)
      // x axis
      const xScale = d3
        .scaleBand()
        .domain(data.map((d) => d.x))
        .range([bufferLeft, svgWidth - bufferRight])
      const xAxis = d3.axisBottom(xScale).tickSize(0).tickSizeOuter(0)
      svg
        .append("g")
        .attr("class", "warehouse-graph-ordanal-labels")
        .attr("transform", `translate(0, ${svgHeight - bufferBottom})`)
        .call(xAxis)
      // bars
      svg
        .append("g")
        .selectAll("rect")
        .data(data)
        .join("rect")
        .attr("x", (d) => xScale(d.x) + barWidth * 0.1)
        .attr("y", (d) => yScale(d.y))
        .attr("height", (d) => svgHeight - yScale(d.y) - bufferBottom)
        .attr("width", barWidth)
        .style("fill", (d, i) => colorScale(i))
      // text labels
      svg
        .append("text")
        .attr("text-anchor", "start")
        .attr("class", "warehouse-graph-lables")
        .attr(
          "x",
          -(bufferTop + bufferBottom + svgHeight) / 2 + svgHeight * 0.13
        )
        .attr("y", bufferLeft - svgWidth * 0.09)
        .text("Time Units")
        .attr("transform", "rotate(-90)")
        .style("font-size", "16px")
      svg
        .append("text")
        .attr("text-anchor", "middle")
        .attr("x", (svgWidth + bufferRight) / 2)
        .attr("y", svgHeight - bufferTop)
        .style("font-size", "22px")
        .style("fill", "#696666")
    }
  }, [data, loading, svgHeight, svgWidth])
  return (
    <div style={{ height: "20vh", width: "100%" }} ref={svgRef}>
      <svg></svg>
    </div>
  )
}

export default LoadingTimes
